export default "../../src/img/patterns/bg.jpeg";